import http from "../../http-common";

export default class AuthService {

    static login(data) {
        return http.post("/user/login", data);
    }

    static signup(data) {
        return http.post("/user/signup", data);
    }

    static verify(userId) {
        return http.get(`/user/verify?userId=${userId}`);
    }
}
